module.exports = __webpack_public_path__ + "static/media/Public_22.7f33df8a.jpg";